import { useParams } from 'react-router-dom';
import { getItem } from 'helpers/store';
import { useGetCompanyDetailByContactIdQuery } from 'services/contactsV2';
import { useGetSharedListBySlugQuery } from 'services/sharedLists';
import { useGetSharedListCompanyDetailsFromContactByIdQuery } from 'services/sharedListV2';

export const useGetCompanyDetail = ({ contact, type }) => {
  const isNotPublic = ['default', 'read', 'matches'].includes(type);

  const { data: privateCompanyDetail, isLoading: isLoadingPrivateCompanyDetail } = useGetCompanyDetailByContactIdQuery(
    contact.id,
    {
      skip: type === 'public',
    },
  );
  const { slug } = useParams();
  const { data: listInfo, isFetching: isFetchingList } = useGetSharedListBySlugQuery(
    { slug },
    {
      skip: isNotPublic,
    },
  );

  const { data: publicCompanyDetail, isLoading: isLoadingPublicContact } =
    useGetSharedListCompanyDetailsFromContactByIdQuery(
      {
        contactId: contact.id,
        slug,
        password: listInfo?.sharedList?.passwordProtected
          ? getItem(`sharedListPwd-${slug}-${listInfo?.sharedList?.id}`)
          : '',
      },
      {
        skip: isNotPublic || isFetchingList,
      },
    );

  return {
    companyList: type === 'public' ? publicCompanyDetail : privateCompanyDetail,
    isLoading: isLoadingPrivateCompanyDetail || isLoadingPublicContact || isFetchingList,
  };
};
